import { FilterContextProps } from "@app/projects/network-assessment/maps/network-coverage-map/contexts/FilterContext";
import { MultiMapExportRouteState } from "@app/projects/network-assessment/multi-map-export/interfaces";

export const buildMultiMapExportLaunchContext = (filterContext: Partial<FilterContextProps>): MultiMapExportRouteState => {
  const launchCounty = filterContext.serviceAreaRegionIdToRegionCodeMap?.get(filterContext.selectedServiceArea);

  return {
    selectedCountyStatuses: filterContext.selectedCountyStatuses,
    selectedProviderSources: filterContext.selectedProviderSources,
    selectedServiceArea: filterContext.selectedServiceArea,
    selectedServiceAreaCountyCode: launchCounty?.countyCode,
    selectedServiceAreaStateCode: launchCounty?.stateCode,
    selectedSpecialtyGroupCode: filterContext.selectedSpecialtyGroupCode?.key,
    selectedSpecialtyGroupName: filterContext.selectedSpecialtyGroupCode?.name,
  };
};
